export const authKey = 'hrmAccessToken';
